<template>
	<div class="position">
		<div>
			<h3 class="popup-tilte">Regisztráció elküldve!</h3>
			<div class="fs-desc popup-content-width">
				Kérjük, szíveskedjen e-mail postafiókját ellenőrizni és az e-mailben küldött linkre kattintva e-mail
				címének helyességét megerősíteni!
				<br />
				Kérjük, azon az eszközön kattintson az e-mailben lévő linkre, amelyen a szerződését meg kívánja kötni.
				<br/>
				Kérjük, hogy a regisztrációs e-mailt a Spam és Promóciók mappában is szíveskedjen megnézni.
			</div>
		</div>
	</div>
</template>

<script>
export default {};
</script>
